import { render, staticRenderFns } from "./products-filter-category.vue?vue&type=template&id=1078b546&"
import script from "./products-filter-category.vue?vue&type=script&lang=js&"
export * from "./products-filter-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports